<template>
  <b-row>
    <img
      class="mx-auto"
      src="/img/loader.svg"
      style="width: 128px"
      alt="Cargando..."
    />
  </b-row>
</template>
<script>
export default {
  name: "loader-ag"
};
</script>
